const CIBERALARMA_PROVISIONING_SUBMIT = 'CIBERALARMA_PROVISIONING_SUBMIT';
const CIBERALARMA_PROVISIONING_SUBMIT_REQUESTED = 'CIBERALARMA_PROVISIONING_SUBMIT_REQUESTED';
const CIBERALARMA_PROVISIONING_SUBMIT_SUCCEEDED = 'CIBERALARMA_PROVISIONING_SUBMIT_SUCCEEDED';
const CIBERALARMA_PROVISIONING_SUBMIT_FAILED = 'CIBERALARMA_PROVISIONING_SUBMIT_FAILED';

export { CIBERALARMA_PROVISIONING_SUBMIT };
export { CIBERALARMA_PROVISIONING_SUBMIT_REQUESTED };
export { CIBERALARMA_PROVISIONING_SUBMIT_SUCCEEDED };
export { CIBERALARMA_PROVISIONING_SUBMIT_FAILED };